<template>
  <div v-if="square > 0" class="print__table_row print__table_sibling">
    <div class="print__table_counter"></div>
    <div>
      <div>
        <b>Деталь {{ index + 1 }}_{{ indexNumber }}</b>
        {{ fullName }}
      </div>
    </div>
    <div>{{ count }} шт.</div>
    <!--    <div>{{ square }} м<sup>2</sup></div>-->
    <div>{{ pricePrepayFormat }} руб</div>
    <div>{{ priceLastPay }} руб</div>
    <div>{{ priceWithDiscountFormat }} руб</div>
  </div>
</template>

<script>
import wNumb from "wnumb";

export default {
  name: "Print-goods-sibling",
  props: {
    value: Object,
    item: Object,
    category: String,
    parentId: Number,
    index: Number,
    letter: String,
    prepay: Number
  },
  data() {
    return {
      typeNames: ["Низ", "Верх", "Пенал"]
    };
  },
  watch: {
    fullName: {
      handler: "updateInfo",
      immediate: true
    }
  },
  computed: {
    fullName() {
      let name = this.name ? `${this.name},` : "";
      let color = this.color ? `${this.color},` : "";
      let typeNames = this.typeNames[this.type - 1];
      let size = `${this.height ?? 0} x ${this.depth ?? 0} x ${this.width ??
        0}`;
      return `${name} ${color} ${typeNames} , ${size}`;
    },
    name() {
      return this.item.name;
    },
    priceCount() {
      return this.item.price * this.square * this.extra;
    },
    price() {
      return wNumb({
        decimals: 0,
        thousand: " "
      }).to(this.priceCount || 0);
    },
    // priceWithDiscount() {
    //   return wNumb({
    //     decimals: 0,
    //     thousand: " "
    //   }).to(this.priceCount * this.discount || 0);
    // },

    priceWithDiscount() {
      return this.priceCount * this.discount ?? 0;
    },
    priceWithDiscountFormat() {
      return wNumb({
        decimals: 0,
        thousand: " "
      }).to(this.priceWithDiscount);
    },
    pricePrepay() {
      let total = (this.priceWithDiscount / 100) * this.prepay;
      return wNumb({
        decimals: 0,
        thousand: ""
      }).to(total ?? 0);
    },
    pricePrepayFormat() {
      return wNumb({
        decimals: 0,
        thousand: " "
      }).to(Number(this.pricePrepay));
    },
    priceLastPay() {
      return wNumb({
        decimals: 0,
        thousand: " "
      }).to(Number(this.priceWithDiscount) - Number(this.pricePrepay));
    },

    discount() {
      return 1 - this.$store.getters.currentCalculation.discount / 100;
    },
    extra() {
      return 1 + this.$store.getters.currentOrder.extra / 100;
    },
    color() {
      return this.item.color;
    },
    square() {
      return this.item.square;
    },
    count() {
      return this.item.count;
    },
    type() {
      return this.item.type;
    },
    article() {
      return this.item.article;
    },
    indexNumber() {
      return this.index + 1;
    },
    width() {
      return this.item.width;
    },
    height() {
      return this.item.height;
    },
    depth() {
      return this.item.depth;
    },
    currentInfo: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  },
  methods: {
    updateInfo() {
      if (!this.currentInfo) {
        this.currentInfo = {};
      }
      this.currentInfo = {
        ...this.currentInfo,
        name: this.fullName,
        count: this.square,
        prepay: this.pricePrepayFormat,
        lastPay: this.priceLastPay,
        price: this.priceWithDiscountFormat
      };
    },
    deleteItem() {
      this.$store.dispatch("deleteSiblings", {
        category: this.category,
        parentId: this.parentId,
        id: this.item.id,
        letter: this.letter
      });
    }
  }
};
</script>
